import { Autocomplete, Button, Dialog, DialogContent, DialogTitle, Grid, TextField } from "@mui/material"
import styles from './styles.module.css'
import InputMask from "react-input-mask";
import { useState } from "react"


const ModalDadosBancarios = ({
    openModal,
    handleCloseModal,
    setActiveStep,
    bankNames,
    dadosBancariosSecundario,
    setDadosBancariosSecundario,
    dataForm,
    setDataForm, }) => {
    const [openDadosSecundarios, setOpenDadosSecundarios] = useState(false)

    const handleSim = () => {
        setActiveStep(6)
        handleCloseModal()
    }

    const handleOpenDadosSecundarios = () => {
        handleCloseModal()
        setOpenDadosSecundarios(true)
    }

    const handleCloseDadosSecundarios = () => {
        setOpenDadosSecundarios(false)
    }

    const handleChange = (e) => {
        const {
            name: key,
            value: newValue
        } = e.target

        setDadosBancariosSecundario({ ...dadosBancariosSecundario, [key]: newValue })
    }

    const handleCancel = () => {
        setDadosBancariosSecundario()
        handleCloseDadosSecundarios()
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setDataForm({
            ...dataForm,
            dadosBancariosSecundario: {
                banco: dadosBancariosSecundario?.banco,
                agencia: dadosBancariosSecundario?.agencia,
                conta: dadosBancariosSecundario?.conta,
                pix: dadosBancariosSecundario?.pix
            }})
        setActiveStep(6)
        handleCloseDadosSecundarios()
    }

    return (
        <>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
            >
                <DialogContent>
                    <p className={styles.titulo}>Os dados bancários informados são <br />os <strong>mesmos</strong> da matriz?</p>
                    <div
                        className={styles.containerBotoes}
                    >
                        <Button
                            className={styles.botaoNao}
                            onClick={handleOpenDadosSecundarios}
                        >
                            Não
                        </Button>
                        <Button
                            className={styles.botaoSim}
                            onClick={handleSim}
                        >
                            Sim
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDadosSecundarios}
                onClose={handleCloseDadosSecundarios}
                fullWidth
                maxWidth='lg'
            >
                <DialogContent>

                    <p className={styles.tituloCadastro}>Por favor, informe os dados bancários da <strong>matriz</strong>:</p>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                            <Grid item xs={12} sm={4}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    value={bankNames.find(item => item === dadosBancariosSecundario?.banco)}
                                    options={bankNames}
                                    onChange={e => setDadosBancariosSecundario({ ...dadosBancariosSecundario, banco: e.target.textContent })}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            error={!dadosBancariosSecundario?.banco}
                                            {...params}
                                            label="Banco"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <InputMask
                                    mask="9999"
                                    maskChar={null}
                                    onChange={handleChange}
                                    value={dadosBancariosSecundario?.agencia}
                                >
                                    {() => (
                                        <TextField
                                            required
                                            error={!dadosBancariosSecundario?.agencia}
                                            size="small"
                                            label="Agência"
                                            name="agencia"
                                            fullWidth
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <InputMask
                                    mask="999999999999"
                                    maskChar={null}
                                    onChange={handleChange}
                                    value={dadosBancariosSecundario?.conta}
                                >
                                    {() => (
                                        <TextField
                                            error={!dadosBancariosSecundario?.conta}
                                            required
                                            size="small"
                                            label="Conta"
                                            name="conta"
                                            fullWidth
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    size="small"
                                    label="PIX"
                                    value={dadosBancariosSecundario?.pix}
                                    name="pix"
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <div className={styles.containerBotoesCadastro} >
                            <Button
                                className={styles.botaoNao}
                                onClick={handleCancel}
                            >
                                Cancelar
                            </Button>
                            <Button
                                className={styles.botaoSim}
                                type="submit"
                            >
                                Prosseguir
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ModalDadosBancarios